export const jobMatchingThreshold = Number(import.meta.env.VITE_APP_RESUME_MATCH_THRESHOLD) || 6.5